module.exports = __webpack_public_path__ + "img/logo-transparent.b146880b.png";